import React from 'react';
import { useTranslation } from 'react-i18next';

import { RecruitmentProcessCollection } from '../../types';
import FunnelBar from './FunnelBar';
import PercentageComparison from './PercentageComparison';

interface FunnelBarWithPercentageComparisonProps {
  totalVacancyPositions: number;
  stageName: string;
  totalCandidates: number;
  previousStageCounter: number;
  accumulatedCounter: number;
  currentStageCounter: number;
  dashboardStatus?: RecruitmentProcessCollection['status'];
}

const FunnelBarWithPercentageComparison: React.FC<FunnelBarWithPercentageComparisonProps> = ({
  totalVacancyPositions,
  stageName,
  totalCandidates,
  previousStageCounter,
  accumulatedCounter,
  currentStageCounter,
  dashboardStatus,
}) => {
  const comparisonReference = accumulatedCounter + previousStageCounter;

  let coloredBarWidth = '100%';
  if (dashboardStatus) {
    coloredBarWidth = `${Math.round((currentStageCounter / accumulatedCounter) * 100)}%`;
  }
  const { t } = useTranslation();
  const fixedStageNames = [t('Inscritos'), t('Triados'), t('Aprovados'), t('Contratados')];

  return (
    <>
      {stageName !== t('Inscritos') && (
        <PercentageComparison
          comparison={Math.round((accumulatedCounter / comparisonReference) * 100)}
          enabled={!dashboardStatus && !!accumulatedCounter}
        />
      )}
      <FunnelBar
        barBackgroundColor={
          dashboardStatus === 'ACTIVE'
            ? '#95DE64'
            : dashboardStatus === 'INACTIVE'
            ? '#CF1322'
            : fixedStageNames.includes(stageName) //acumulado
            ? '#017EA6'
            : '#27BCEE'
        }
        containerWidth={`${(accumulatedCounter / totalCandidates) * 100}%`}
        coloredBarWidth={coloredBarWidth}
        stageName={stageName}
        stageCounter={dashboardStatus ? currentStageCounter : undefined}
        accumulatedStageCounter={accumulatedCounter}
        totalVacancyPositions={totalVacancyPositions}
        enabled={!!accumulatedCounter}
      />
    </>
  );
};

export default FunnelBarWithPercentageComparison;
